export const BUSINESS_TYPES = [
  { id: 3, name: "Truck Parking Facility" },
  { id: 7, name: "Parking Facility" },
  { id: 2, name: "RV Boat Storage" },
  { id: 13, name: "Truck Stop" },
  { id: 14, name: "Truck Repair Shop" },
  { id: 4, name: "Hotels" },
  { id: 1, name: "Self Storage" },
  { id: 5, name: "Convenience/Grocery Store" },
  { id: 6, name: "Apartment" },
  { id: 8, name: "Church" },
  { id: 10, name: "Commercial Lot" },
  { id: 9, name: "Warehouse" },
  { id: 11, name: "Food Truck Lot" },
  { id: 12, name: "RV Park" },
  { id: 15, name: "Towing Yard" },
  { id: 16, name: "CDL School" },
];

export const BUSINESS_TYPE_LABELS = BUSINESS_TYPES.reduce(
  (labels, type) => ({ ...labels, [type.id]: type.name }),
  { 0: "Residential" }
);

export const FACILITY_BUSINESS_TYPE_IDS = new Set([1, 2, 3, 7, 13, 14]);

export const getAgreementCategoryLabel = (businessType) =>
  FACILITY_BUSINESS_TYPE_IDS.has(Number(businessType))
    ? "Facility Partnership Agreement"
    : "Non-Facility Partnership Agreement";
